import React, { FC, useEffect, useState } from "react";
import { BarLoader } from "react-spinners";
// shared
import { Title } from "shared/ui/title";
import { BaseInput } from "shared/ui/input";
import { Button } from "shared/ui/button";
import SearchIcon from "shared/icons/controls/search.svg";
import icon from "shared/icons/navbar/school-active.svg";
// widgets
import { SchoolListWidget } from "widgets/schools/ui";
// features
import { ModuleCreateUsersFeature } from "features/module/module-add-users";
// effector
import { useStore } from "effector-react";
// entities
import { SchoolModel } from "entities/school";

const SchoolPage: FC = () => {
  const [visible, setVisible] = useState(false);
  const [searchText, setSearchText] = useState("");

  const allUsersSchool = useStore(SchoolModel.$allSchools);
  const isLoading = useStore(SchoolModel.getAllSchoolsWithNameFx.pending);

  const handleAddButtonClick = () => {
    setVisible(!visible);
  };

  useEffect(() => {
    SchoolModel.getAllSchoolsWithNameFx();
  }, []);

  return (
    <div style={{ height: "calc(100vh - 70px)" }} className={"bg-[#F5F8FE]"}>
      <div className={"w-full px-4 py-4 h-[100%]"}>
        <Title className={"mb-6"} dark>
          Онлайн-школы
        </Title>
        <div
          className={
            "flex justify-between items-center mb-5 bg-[#EAF2FC] p-3 rounded-xl"
          }
        >
          <div className={"w-[38%]"}>
            <BaseInput
              placeholder={"Найти школу"}
              renderLeftIcon={SearchIcon}
              onInputChange={setSearchText}
            />
          </div>
          <div className={"flex"}>
            <div className={"w-[201px]"}>
              <Button onClick={handleAddButtonClick}>Добавить</Button>
            </div>
          </div>
        </div>
        {!isLoading ? (
          <SchoolListWidget
            users={allUsersSchool}
            type="school"
            searchText={searchText}
          />
        ) : (
          <div className="flex items-center justify-center w-full h-[74%]">
            <BarLoader color="#36D7B7" width={500} loading={isLoading} />
          </div>
        )}
        {visible && (
          <div className="overlay">
            <ModuleCreateUsersFeature
              icon={icon}
              title="Новая онлайн-школа"
              onChange={handleAddButtonClick}
              visible={visible}
              options={[
                { label: "Активный", value: "ACTIVE" },
                { label: "Приостановлен", value: "INACTIVE" },
              ]}
              role="school"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export { SchoolPage };
